/**
 * @flow
 * Created by neo on 18.07.17.
 */
import mobx, { observable, action } from 'mobx';
import BackendFactory from '../Services/BackendFactory';

const defaultValues = {
  defaultLanguage: 'en',
  payment_types: [
    {
      id: 1,
      name: 'ON_SITE'
    }
  ],
  currency: {
    id: 1,
    code: 'EUR',
    conversion_rate_eur: 1
  }
};

export class SettingsClass {
  @observable companyId: string;
  @observable settings = observable.map(defaultValues);
  @observable enums = observable.map({});

  constructor(json?: any) {
    if(json) {
      this.fromJson(json);
    }
  }
  
  @action fromJson(json?: any) {
    this.companyId = json.settings.client_id;
    this.settings = observable.map(this.getSettings(json.settings || {}));
    this.enums = observable.map(json.enums || {});
  }
  
  getSettings(json: any): any {
    for(let key in json) {
      if(json.hasOwnProperty(key)) {
        const defaultValue = defaultValues[key];
        if(defaultValue && typeof defaultValue === 'object' && !Array.isArray(defaultValue)) {
          const copy = Object.assign({}, defaultValue);
          json[key] = Object.assign(copy, json[key]);
        }
      }
    }
    return json;
  }

  @action async load() {
    const backend = await BackendFactory();
    const res = await backend.get('/settings');
    this.fromJson(res.data);
    return this;
  }

  @action async save() {
    const backend = await BackendFactory();
    const res = await backend.post('/settings', mobx.toJS(this));
  }
}

const Settings = new SettingsClass();
export default Settings;



// WEBPACK FOOTER //
// ./src/App/Store/Settings.js